import React from 'react';
import { Segmented, Tag } from 'antd';
import { CheckCircleFilled } from '@ant-design/icons';

export default function MemberTabs({ members, selectedMemberId, onChange }) {
  const options = members.map((m) => ({
    label: (
      <span>
        {m.member_name}
        {m.submitted && (
          <CheckCircleFilled style={{ color: '#389e0d', marginLeft: 6 }} />
        )}
      </span>
    ),
    value: m.member_id,
  }));

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 12, rowGap: 8, marginBottom: 16 }}>
      <Segmented options={options} value={selectedMemberId} onChange={onChange} />
      <Tag color="green">
        제출 완료 {members.filter((m) => m.submitted).length}/{members.length}
      </Tag>
    </div>
  );
}
